import styled from 'styled-components';
import('./widget.scss');
export const Container = styled.div`
  width: 100%;
`;
export const CenteredContainer = styled.div`
  max-width: 1286px;
  margin: 0 auto;
`;